(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["authorized-price-menu"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('aw-price-menu')){
customElements.define('aw-price-menu',class extends HTMLElement{
connectedCallback(){
this.details=this.querySelector('details');
this.closeOutside=event=>{if(!this.contains(event.target))this.details.open=false};
this.closeEscape=event=>{if(event.key==='Escape'&&this.details.open){this.details.open=false;this.querySelector('summary').focus()}};
this.closeOthers=()=>{if(this.details.open)document.querySelectorAll('aw-price-menu').forEach(menu=>{if(menu!==this)menu.querySelector('details').open=false})};
document.addEventListener('click',this.closeOutside);this.addEventListener('keydown',this.closeEscape);this.details.addEventListener('toggle',this.closeOthers);
}
disconnectedCallback(){document.removeEventListener('click',this.closeOutside);this.removeEventListener('keydown',this.closeEscape);this.details.removeEventListener('toggle',this.closeOthers)}
});
}
  } catch(e) { console.error(e); }
})();

})();
